import iconOne from '../../assets/features/1.png';
import iconTwo from '../../assets/features/2.png';
import iconThree from '../../assets/features/3.png';
import iconFour from '../../assets/features/4.png';

const featuresData = [
    {
        'icon': iconOne,
        'title': 'Safety First',
        'description': 'At Loft Dentaire Laval, we prioritize safety with strict health protocols and sterilization procedures.'
    },
    {
        'icon': iconTwo,
        'title': 'Insurance Accepted',
        'description': 'We work with most major insurance providers to ensure affordable dental care for all our patients.'
    },
    {
        'icon': iconThree,
        'title': 'Full-Service Dentistry',
        'description': 'Our clinic offers a full range of dental services from general dentistry to specialized treatments like implants and orthodontics.'
    },
    {
        'icon': iconFour,
        'title': 'Patient-Centered Care',
        'description': 'We provide gentle, compassionate care for patients of all ages in a comfortable, welcoming environment.'
    }
]

export default featuresData;
